import { HStack, RadioGroup, Spacer, Stack } from "@chakra-ui/react";
import * as React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";

import { OptimizationTarget } from "../../types/optimization-rule";
import { Field } from "../field";
import { StepContent } from "./step-content";
import { OptimizationFormData } from "./types";

const targetOptions = [
  { label: "First-Order Profit", value: OptimizationTarget.FOP },
  { label: "Customer Lifetime Value (LTV)", value: OptimizationTarget.CLTV },
  { label: "Customer Lifetime Profit (LTP)", value: OptimizationTarget.CLTP },
  {
    label: "Conversion Propensity",
    value: OptimizationTarget.CP,
  },
  {
    label: "Custom",
    value: OptimizationTarget.Custom,
  },
];

export function TargetStep() {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<OptimizationFormData>();

  const target = useWatch({ control, name: "target" });

  React.useEffect(() => {
    if (target === OptimizationTarget.CP) {
      setValue("timeframe", "7");
    } else if (target !== OptimizationTarget.FOP) {
      setValue("timeframe", "365");
    }
  }, [target, setValue]);

  return (
    <StepContent title="Optimization Target">
      <Field invalid={!!errors.target} errorText={errors.target?.message}>
        <Controller
          name="target"
          control={control}
          render={({ field }) => (
            <RadioGroup.Root
              value={field.value}
              onValueChange={(e) => field.onChange(e.value)}
              onBlur={field.onBlur}
              name={field.name}
              colorPalette="blue"
            >
              <Stack>
                {targetOptions.map((option) => (
                  <RadioGroup.Item key={option.value} value={option.value}>
                    <RadioGroup.ItemHiddenInput />
                    <RadioGroup.ItemIndicator />
                    <RadioGroup.ItemText>
                      <HStack>
                        <span>{option.label}</span>
                      </HStack>
                    </RadioGroup.ItemText>
                  </RadioGroup.Item>
                ))}
              </Stack>
            </RadioGroup.Root>
          )}
        />
      </Field>
      <Spacer />
    </StepContent>
  );
}
